import { render, staticRenderFns } from "./chartareastock.vue?vue&type=template&id=f7f46a04&"
import script from "./chartareastock.vue?vue&type=script&lang=js&"
export * from "./chartareastock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports